export default __webpack_public_path__ + "static/media/CHEAPESTPRICE.d3ace965.svg";